import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagCW(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURQRBowI4kAAygQM8mf7GPP3HRPX2916DvzRirs7Y6JSs0hV7gYIAAAEzSURBVDjL3Yw9SwNBEIZHFuJHlc02lkl+wRzTaJdCewvtrRauEwJuKxyI6ayipRI4xF/pO3ObFObukiKNvszOOx/PDtFfUdoFfPevj1NMD33AyTKWTx07h3B0Gl9dlxRwg3jPUMuamUgcL17exbkzRsJbG2vhmGCVXLDIc+WExQgz0cAJQRZVvbKFyQw8BqQcXkrLtzS3HVt2GaXGZRFjLCvZ0gbgOsYP6QHkMpbSChRZgxhdKCSoLItoNyR0Vj2u6nlQohDgsCJoyxQ8Koy+wvmnDUODmYLHBciDOioQKHWKjG9eESbUiOBVQSNYawTaIeWxt4MZbXCdeQVatWY6AX9IYDJqojEo997SHhfu+nVzAOCqU9eaZrTpbu39rmc9FzIw7deYJtORRratGO++8C+AH9cyvn12jY3gAAAAAElFTkSuQmCC",
    alt: "CW"
  }, props));
}